import axios from 'axios';

const API_URL = 'https://api.paragaia.tn';

const getUserId = () => {
  return localStorage.getItem('client_id');
};

export const addItemToCart = async (productId, quantity = 1) => {
  const token = localStorage.getItem('access_token');
  const userId = getUserId();
  if (!token || !userId) return null;

  try {
    const response = await axios.post(
      `${API_URL}/cart/${userId}/item`,
      { productId, quantity },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error adding item to cart:', error);
    return null;
  }
};

export const updateCartItemQty = async (productId, quantity) => {
  const token = localStorage.getItem('access_token');
  const userId = getUserId();
  if (!token || !userId) return null;

  try {
    const response = await axios.patch(
      `${API_URL}/cart/${userId}/item/${productId}`,
      { quantity },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error updating item quantity:', error);
    return null;
  }
};

export const removeCartItem = async (productId) => {
  const token = localStorage.getItem('access_token');
  const userId = getUserId();
  if (!token || !userId) return null;

  try {
    const response = await axios.delete(
      `${API_URL}/cart/${userId}/item/${productId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error removing item from cart:', error);
    return null;
  }
};

export const clearCart = async () => {
  const token = localStorage.getItem('access_token');
  const userId = getUserId();
  if (!token || !userId) return null;

  try {
    const response = await axios.delete(
      `${API_URL}/cart/${userId}/clear`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error clearing cart:', error);
    return null;
  }
};

export const fetchCart = async () => {
  const token = localStorage.getItem('access_token');
  const userId = localStorage.getItem('client_id');
  const role = localStorage.getItem('role');

  if (!token || !userId || role === 'admin') {
    return { items: [] };
  }

  try {
    const response = await axios.get(`${API_URL}/cart/${userId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    if (error.response?.status === 404) {
      return { items: [] };
    }

    console.error('Unexpected error fetching cart:', error);
    return { items: [] };
  }
};
